import { Component, OnInit } from '@angular/core';
import { VernostServiceService } from "../../services/vernost-service.service";
import { Router } from "@angular/router";
@Component({
  selector: 'app-miles-xand-y',
  templateUrl: './miles-xand-y.component.html'
})
export class MilesXandYComponent implements OnInit {

  constructor(
    private vernostService: VernostServiceService,
    private router: Router) {

  }
  submit: any = [];
  loader = false;
  Xvalue: any
  Yvalue: any

  ngOnInit() {
    this.vernostService.showXandY().subscribe(response => {
      this.Xvalue = response[0].result[0].HPM
      this.Yvalue = response[0].result[0].NMO
    })
  }

  insertJpValue() {
    document.getElementById("loder_div").style["display"] = "none";
    this.loader = true;
    let field1 = this.submit.MILES_Value;
    let field2 = this.submit.NEAREST_Value;
    console.log(field1, "testing");
    this.Xvalue = field1
    this.Yvalue = field2


    let milescalc = {
      HPM: this.submit.MILES_Value,
      NMO: this.submit.NEAREST_Value
    };

    this.vernostService.submitmilescalc(milescalc).subscribe(response => {
      document.getElementById("loder_div").style["display"] = "block";
      this.loader = false;
    })

  }
}
